import type { Attachment, AttachmentType } from "@repo/types";
import { storage } from "@/services/storage";
import { extractExtension } from "@repo/lib/extractExtension";
import shortUUID from "short-uuid";

export class AttachmentRepository {
  /** Generate an attachment for a document by uploading the given file. */
  async upload({
    file,
    tenantId,
    documentId,
    attachmentId,
    attachmentType = "original",
  }: {
    file: File;
    tenantId: string;
    documentId: string;
    attachmentId: string;
    attachmentType?: AttachmentType;
  }): Promise<Attachment> {
    const extension = extractExtension(file.name);
    const path = `${tenantId}/attachments/${attachmentId}${extension ? "." + extension : ""}`;
    const url = await storage.upload(file, path, { documentId });

    return {
      attachmentType,
      isUrl: false,
      name: file.name,
      url,
      path,
      mimeType: file.type,
      extension,
      sizeBytes: file.size,
      attachmentId,
    };
  }

  init(data?: Partial<Attachment>): Attachment {
    return {
      attachmentType: "original",
      name: "",
      url: "",
      path: "",
      attachmentId: shortUUID.generate(),
      ...data,
    };
  }
}

export const attachmentRepo = new AttachmentRepository();
